export type PromoBanner = {
  id: string;
  expireAt: number; // unix timestamp (seconds)
  imageSrc: string;
};

export const promoBanners: PromoBanner[] = [
  {
    id: "new-location-lockland",
    expireAt: Math.floor(new Date("2027-01-01T23:59:59Z").getTime() / 1000),
    imageSrc: "/images/new-location-lockland.png",
  },
  {
    id: "promo-21-AA",
    expireAt: Math.floor(new Date("2026-06-21T23:59:59Z").getTime() / 1000),
    imageSrc: "/images/promo-21-AA.png",
  },
  {
    id: "promo-19-AA",
    expireAt: Math.floor(new Date("2026-06-19T23:59:59Z").getTime() / 1000),
    imageSrc: "/images/promo-19-AA.png",
  },
];

export default promoBanners;
